import React, { useEffect, useState } from 'react'

import { BasicModal } from '@/components/layout/modals/BasicModal'
import { Button } from '@/components/buttons/Button'
import { FormField } from '@/components/forms/FormField'
import { TextInput } from '@/components/forms/TextInput'

export const KodiReportEditModal = ({ show, initialTitle, onClose, onSave, saving }) => {
  const [draft, setDraft] = useState(initialTitle || '')

  useEffect(() => {
    if (show) {
      setDraft(initialTitle || '')
    }
  }, [show, initialTitle])

  const handleSave = () => {
    const trimmed = draft.trim()
    if (!trimmed) {
      return
    }
    onSave(trimmed)
  }

  if (!show) {
    return null
  }

  return (
    <BasicModal
      size="tiny"
      show
      title="Rename chart"
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button brand onClick={handleSave} disabled={saving || !draft.trim()} loading={saving}>
            Save
          </Button>
        </>
      }
    >
      <FormField label="Chart name">
        <TextInput
          // FormField's label isn't tied to its control, so name the field here.
          aria-label="Chart name"
          value={draft}
          onChange={(event) => {
            return setDraft(event.target.value)
          }}
          placeholder="e.g. Call outcomes by day"
          autoFocus
        />
      </FormField>
      <p className="kodi-report-edit__hint">
        To change the data, ask Kodi for a new chart and pin it.
      </p>
    </BasicModal>
  )
}
